import { GraphQlRequestService } from '../../../api/graphql-request-service';
import { Domains, EXECUTOR_ROLE_KEY } from '../../constants';
import { Hasher } from '../hasher';
import { JsonLocalStorageService } from '../local-storage-service';
import { HasDependencies, hashString, Role, RoleId } from '../types';
import { handleGQLErrors } from '../utils';

export interface RoleService extends HasDependencies {
  getEffectiveRoleId: (simulatedRole: Role | null) => RoleId;
  getExecutorRolesForRole: (roleId: RoleId, domain: Domains) => Promise<Role[]>;
}

export class BackendRoleService implements RoleService {
  constructor(
    readonly graphQlRequestService: GraphQlRequestService,
    readonly userRoleId: RoleId,
    readonly simulatedRole: Role | null
  ) {}

  public getDeps = () => [
    hashString([
      ...this.graphQlRequestService.getDeps(),
      this.userRoleId,
      Hasher.hash(this.simulatedRole),
    ]),
  ];

  public getExecutorRolesForRole = async (
    roleId: RoleId,
    domain: Domains
  ): Promise<Role[]> => {
    const result = await handleGQLErrors(
      this.graphQlRequestService.graphQlSdk.listExecutorRolesForRole({
        roleId,
        domainFilter: domain,
        simulateRole: this.simulatedRole?.id ?? null,
      })
    );
    return (
      result.listExecutorRolesForRole?.map((r) => ({
        id: r.id,
        name: r.name,
        domain: r.domain as Domains,
      })) ?? []
    );
  };

  public getEffectiveRoleId = (): RoleId => {
    return this.simulatedRole?.id ?? this.userRoleId;
  };
}

export const LocalStorageExecutorRoleService =
  new JsonLocalStorageService<Role>(EXECUTOR_ROLE_KEY);
